export const pythonApiExample = `import requests
import json
import hmac
import hashlib
import os
from datetime import datetime
import uuid

# Configuration
API_BASE_URL = "https://app.reasonshield.com/api/v1"
API_ENDPOINT_PATH = "/lis-webhook/vendor"
VENDOR_ID = os.getenv("VENDOR_ID")
API_KEY = os.getenv("VENDOR_API_KEY")
WEBHOOK_SECRET = os.getenv("VENDOR_WEBHOOK_SECRET")

# Generate HMAC signature for the payload
def generate_signature(payload, secret):
    # Convert payload to JSON string with consistent ordering
    payload_string = json.dumps(payload, separators=(',', ':'), sort_keys=True)
    payload_bytes = payload_string.encode('utf-8')
    
    # Create signature
    signature = hmac.new(
        secret.encode('utf-8'),
        payload_bytes,
        hashlib.sha256
    ).hexdigest()
    
    return signature

# Submit data with both authentication methods
def submit_data(test_data):
    # Prepare request payload
    payload = {
        "vendor_id": VENDOR_ID,
        "timestamp": datetime.now().isoformat(),
        "request_id": str(uuid.uuid4()),
        "test_data": test_data
    }
    
    # Generate signature for the payload
    signature = generate_signature(payload, WEBHOOK_SECRET)
    
    # Set up headers with BOTH authentication methods
    headers = {
        "Content-Type": "application/json",
        "Authorization": f"Bearer {API_KEY}",         # API Key Authentication
        "X-Vendor-Signature": signature               # Signature Verification
    }
    
    url = f"{API_BASE_URL}{API_ENDPOINT_PATH}/submit-data"
    response = requests.post(url, json=payload, headers=headers)
    
    if response.status_code == 202:
        return response.json()
    else:
        raise Exception(f"Error submitting data: {response.text}")

# Check status
def check_status(data_id):
    headers = {
        "Authorization": f"Bearer {API_KEY}"
    }
    
    url = f"{API_BASE_URL}{API_ENDPOINT_PATH}/status/{data_id}"
    response = requests.get(url, headers=headers)
    
    if response.status_code == 200:
        return response.json()
    else:
        raise Exception(f"Error checking status: {response.text}")

# Get report
def get_report(data_id):
    headers = {
        "Authorization": f"Bearer {API_KEY}"
    }
    
    url = f"{API_BASE_URL}{API_ENDPOINT_PATH}/report/{data_id}"
    response = requests.get(url, headers=headers)
    
    if response.status_code == 200:
        return response.json()
    else:
        raise Exception(f"Error retrieving report: {response.text}")

# Example usage
try:
    # Create test data
    test_data = {
        "test_id": "12345",
        "panel_type": "RESPIRATORY",
        "patient_info": {
            "patient_id": "PT-789456",
            "age": 45,
            "gender": "M"
        },
        "collection_info": {
            "collection_date": "2024-09-10T13:11:00-06:00",
            "specimen_type": "nasopharyngeal swab"
        },
        "test_details": {
            "viruses": [
                {"name": "Influenza A", "result": "Not Detected"},
                {"name": "SARS-CoV-2", "result": "Detected"}
            ],
            "bacteria": [
                {"name": "Streptococcus pneumoniae", "result": "Not Detected"},
                {"name": "Mycoplasma pneumoniae", "result": "Not Detected"}
            ]
        }
    }
    
    # Submit the data
    result = submit_data(test_data)
    print(f"Data submitted successfully. ID: {result.get('data_id')}")
    
    # Get the data ID
    data_id = result.get('data_id')
    
    # Check status (in a real implementation, you'd add a delay or poll)
    status_result = check_status(data_id)
    print(f"Status: {status_result.get('status')}")
    
    # If processing is complete and report is available, get the report
    if status_result.get('status') == 'COMPLETED' and status_result.get('report_available'):
        report = get_report(data_id)
        print(f"Retrieved report with risk assessment: {report['report_data']['risk_assessment']['overall_risk']}")
    
except Exception as e:
    print(f"Error: {str(e)}")`; 